import _ from "lodash";

import { QuestionnaireElementType } from "@shared/questionnaireElementType";

export { PAGE_TYPE_OL } from "@shared/questionnaireConstants";
export { PAGE_TYPE_OL_IMAGE } from "@shared/questionnaireConstants";
export { PAGE_TYPE_IMAGE } from "@shared/questionnaireConstants";
export { PAGE_TYPE_COLOR } from "@shared/questionnaireConstants";
export { PAGE_TYPE_SOVA3D } from "@shared/questionnaireConstants";
// export {PAGE_TYPE_TRIDIFY} from "@shared/questionnaireConstants";
export { PAGE_TYPE_OPTIONS } from "@shared/questionnaireConstants";
export { PAGE_TYPE_OPTION_NEEDS_LICENSE } from "@shared/questionnaireConstants";

export { PAGE_LAYOUT_WIDE } from "@shared/questionnaireConstants";
export { PAGE_LAYOUT_NARROW } from "@shared/questionnaireConstants";
export { PAGE_LAYOUT_OPTIONS } from "@shared/questionnaireConstants";

export { PAGE_ALIGNMENT_LEFT } from "@shared/questionnaireConstants";
export { PAGE_ALIGNMENT_CENTER } from "@shared/questionnaireConstants";
export { PAGE_ALIGNMENT_RIGHT } from "@shared/questionnaireConstants";
export { PAGE_ALIGNMENT_OPTIONS } from "@shared/questionnaireConstants";

export const KEY_DOESNOT_EXIST = "KEY_DOESNOT_EXIST";

// List of geo question element types
export const GEOTYPES = _.compact(
  _.map(QuestionnaireElementType.list, (e) => (e.isGeoQuestion ? e.name : null))
);

// List of geo question element types
export const QUESTIONTYPES = _.compact(
  _.map(QuestionnaireElementType.list, (e) => (e.isQuestion ? e.name : null))
);

export const MAX_NUM_BINS = 20;
export const MIN_NUM_BINS = 2;

// Dictionary for Maptionnaire element types -> OL Draw interaction types
// TODO take the OL values from ol
export const DRAWTYPES = {
  geoPoint: "Point",
  geoLine: "LineString",
  geoArea: "Polygon",
  geoBudgetingPoints: "Point",
};

// The order for different layer types
export const ZINDEX = {
  imageGroup: {
    start: 0,
    end: 1000,
  },
  baseMapGroup: {
    start: 0,
    system: 0,
    custom: 100,
    end: 1000,
  },
  overlayGroup: {
    start: 1000,
    system: 1000,
    custom: 2000,
    end: 10000,
  },
  responseLayerGroup: {
    start: 10000,
    geoArea: 10000,
    geoLine: 20000,
    geoPoint: 30000,
    geoBudgetingPoints: 40000,
    end: 50000,
  },
  publicResponseLayerGroup: {
    start: 10000,
    geoArea: 10000,
    geoLine: 20000,
    geoPoint: 30000,
    geoBudgetingPoints: 40000,
    end: 50000,
  },
  responseLayerPageOffset: 100,
};

// These are in rem units (16px) and need to match with
// the values in /styles/dimensions.scss
export const PAGE_LAYOUT_WIDE_WIDTH = 64;
export const PAGE_LAYOUT_NARROW_WIDTH = 30;
export const POPUP_LAYOUT_WIDE_WIDTH = 77.5;

// The id and class name for the OL map containers
export const OL_MAP_TARGET = "ol-map-target";
export const OL_ANALYSIS_MAP_TARGET = "ol-analysis-map-target";

// The global id for th questionnaire page container
export const QUESTIONNAIRE_PAGE_ID = "questionnaire-page-id";

export default {
  ZINDEX: ZINDEX,
  GEOTYPES: GEOTYPES,
  DRAWTYPES: DRAWTYPES,
  MAX_NUM_BINS: MAX_NUM_BINS,
  MIN_NUM_BINS: MIN_NUM_BINS,
  QUESTIONTYPES: QUESTIONTYPES,
  OL_MAP_TARGET: OL_MAP_TARGET,
  OL_ANALYSIS_MAP_TARGET: OL_ANALYSIS_MAP_TARGET,
  QUESTIONNAIRE_PAGE_ID: QUESTIONNAIRE_PAGE_ID,
};

export const GRAPHCOLORS = [
  "#21e839",
  "#377eb8",
  "#e47cc8",
  "#bb3acf",
  "#d64b00",
  "#00d2d5",
  "#4b8009",
  "#1a1a1d",
  "#205b6c",
  "#1e0521",
  "#bb7db2",
  "#ba7338",
];

// See also styles/colors.scss
export const BRAND_COLOR_PALETTE = {
  brandViolet02: "#4447B2",
  brandOrange02: "#ED7F50",
  brandAcqua02: "#58CDCD",
  brandRed02: "#E14460",
  brandBlue02: "#46B0DD",
  brandGreen02: "#27825F",
  brandGrey02: "#676F7C",
  brandViolet03: "#686CCA",
  brandOrange03: "#F89F60",
  brandAcqua03: "#96F0E6",
  brandRed03: "#ED7684",
  brandBlue03: "#86C8F4",
  brandGreen03: "#59C06F",
  brandGrey03: "#C0CCD8",
  brandViolet04: "#99AFED",
  brandOrange04: "#FAD09E",
  brandAcqua04: "#C1F6EA",
  brandRed04: "#FAAF9E",
  brandBlue04: "#C4E4FF",
  brandGreen04: "#C2F1A7",
  brandGrey04: "#F0F5F9",
  brandViolet01: "#200660",
  brandOrange01: "#662500",
  brandAcqua01: "#18474E",
  brandRed01: "#5F0721",
  brandBlue01: "#18374E",
  brandGreen01: "#004D39",
  brandGrey01: "#353D4C",

  // vantaa colors, used in vuetify theme
  vantaaBlue: "#3c8fde",
  vantaaBlueDark: "#0042a5",
  vantaaGreyLight: "#f0f3f8",
};

export const MAX_RESPONSE_SIZE_IN_BYTES = 100000;
